module.exports = __webpack_public_path__ + "static/img/build.51c1129d.svg";